
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VaporWaveEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             // Sun
             const sunR = 250 * scale;
             ctx.save();
             ctx.globalAlpha *= 0.4 / (layerIndex + 1);
             const grad = ctx.createLinearGradient(0, -sunR, 0, sunR);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.arc(0, -height*0.2, sunR, 0, Math.PI * 2);
             ctx.fill();
             
             // Sun stripes
             ctx.globalAlpha = 1;
             ctx.fillStyle = "#000000"; // Assuming dark theme background
             for (let i = 0; i < 10; i++) {
                 const y = -height*0.2 + (i / 10) * sunR * 2 - sunR;
                 const h = (i / 10) * 10 * scale;
                 if (y > -height*0.2) ctx.fillRect(-sunR, y, sunR * 2, h);
             }
             ctx.restore();

             // Floating palm silhouette (abstract)
             const palmX = Math.sin(curTime * 0.1) * width * 0.5;
             ctx.save();
             ctx.translate(palmX, height*0.3);
             ctx.globalAlpha *= 0.2;
             ctx.fillRect(-10 * scale, -200 * scale, 20 * scale, 200 * scale);
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
